import type { CheckoutStateConfig, CheckoutViewState } from "../types/checkout";

export const CHECKOUT_STATE_CONFIG: Record<CheckoutViewState, CheckoutStateConfig> = {
  SCAN: {
    title: "Scan Code",
    subtitle: "Scan the QR code with your Estia mobile app",
    mobileSubtitle: "Tap below to pay with the Estia app on this phone",
    showQr: true,
  },
  SUCCESS: {
    title: "Payment successful",
    subtitle: "You paid",
    showAmount: true,
  },
  FAILED: {
    title: "Payment failed",
    subtitle: "Oops, something went wrong. Here goes the reason why...",
  },
  TIMEOUT: {
    title: "QR Timed out",
    subtitle: "A new Estia QR code is required",
    actionLabel: "Get New QR",
  },
};

export const CHECKOUT_FOOTER = {
  copyright: "Copyright © 2026 Estia Payments. Allrights reserved.",
  privacyLabel: "Privacy Policy",
};
